import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Loading } from '../../../../../../../../common/loading'
import { Panel } from '../../../../../../../../common/panel'
import { SCREEN } from '../../../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { Table } from '../../../../../../../../common/table'
import { SORT_DIRECTION } from '../../../../../../../../utils/common'
import { selectCompanyInfo } from '../../../../../../../common/header/companyInfo/store/slice'
import { selectTypePeriod } from '../../../../../store/slice'
import { TYPE_SORT_BY } from './constants'
import { schemaTable } from './schema/schemaTable'
import {
  changeFilter,
  changeIds,
  getDataReduxTable,
  selectDataRawTable,
  selectFilter,
  selectIdsRawTable,
  selectIdsTable,
  selectLoadingDownload,
  selectLoadingTable,
} from './store/slice'
import { downloadLinkageScore, getLinkageScore } from './store/thunk'

export const CorporateLinkageScore = ({ isDynamicReport }) => {
  const dispatch = useDispatch()

  const { organizationId } = useSelector(selectCompanyInfo)
  const ids = useSelector(selectIdsTable)
  const isLoading = useSelector(selectLoadingTable)
  const isLoadingDownload = useSelector(selectLoadingDownload)
  const locale = useSelector((state) => state.i18n.locale)
  const TimeFrequency = useSelector(selectTypePeriod)
  const dataTable = useSelector(selectDataRawTable)
  const filter = useSelector(selectFilter)
  const idsRaw = useSelector(selectIdsRawTable)
  const { currency, multiplier } = useFormatCurrency(SCREEN.SCORE)

  //Actions
  const handleDownloadLinkageScore = () => {
    return downloadLinkageScore({
      OrganizationId: organizationId,
      TimeFrequency: TimeFrequency,
      Currency: currency,
      Unit: multiplier,
    })
  }

  const handleChangeSort = (value) => {
    dispatch(changeFilter(value))
  }

  //useEffect
  useEffect(() => {
    if (!organizationId || isDynamicReport) return
    dispatch(getLinkageScore({ OrganizationId: organizationId }))
  }, [organizationId, locale])

  useEffect(() => {
    if (filter?.sortDirection === SORT_DIRECTION.ASC) {
      const newIds = [...dataTable]
        .sort((a, b) =>
          filter.sortBy === TYPE_SORT_BY.ORG_NAME ||
          filter.sortBy === TYPE_SORT_BY.RELATIONSHIP
            ? a[filter.sortBy]
                ?.toString()
                .localeCompare(b[filter.sortBy], 'vi')
                ?.toString()
            : a[filter.sortBy] - b[filter.sortBy],
        )
        .sort((a, b) => {
          if (filter.sortBy === TYPE_SORT_BY.RELATIONSHIP) {
            if (a[filter.sortBy] === b[filter.sortBy]) {
              return a[TYPE_SORT_BY.ORG_NAME]
                ?.toString()
                .localeCompare(b[TYPE_SORT_BY.ORG_NAME], 'vi')
                ?.toString()
            }
          }
          return 0
        })
        .map((item) => item.organizationId)
      dispatch(changeIds(newIds))
    }
    if (filter?.sortDirection === SORT_DIRECTION.DESC) {
      const newIds = [...dataTable]
        .sort((a, b) =>
          filter.sortBy === TYPE_SORT_BY.ORG_NAME ||
          filter.sortBy === TYPE_SORT_BY.RELATIONSHIP
            ? b[filter.sortBy]
                ?.toString()
                .localeCompare(a[filter.sortBy], 'vi')
                ?.toString()
            : b[filter.sortBy] - a[filter.sortBy],
        )
        .sort((a, b) => {
          if (filter.sortBy === TYPE_SORT_BY.RELATIONSHIP) {
            if (a[filter.sortBy] === b[filter.sortBy]) {
              return a[TYPE_SORT_BY.ORG_NAME]
                ?.toString()
                .localeCompare(b[TYPE_SORT_BY.ORG_NAME], 'vi')
                ?.toString()
            }
          }
          return 0
        })
        .map((item) => item.organizationId)
      dispatch(changeIds(newIds))
    }
    if (filter?.sortDirection === null) {
      dispatch(changeIds(idsRaw))
    }
  }, [filter, dataTable])

  const renderTable = (dynamic) => (
    <Table
      ids={ids}
      getDataFromRedux={getDataReduxTable}
      isLoading={isLoading}
      isNoDataWithHead={!dynamic}
      noDataText="score.premium.NODATA_TABLE"
      schema={schemaTable(dynamic)}
      autoHeightMax={332}
      changeSort={handleChangeSort}
      sort={filter}
      isDisplayScroll={!dynamic}
      isNoStickyHead={dynamic}
      isDynamicReport={dynamic}
    />
  )

  if (isDynamicReport) return renderTable(isDynamicReport)

  return (
    <>
      <Panel
        label="score.premium.CORPORATE_LINKAGE_SCORE"
        isI18n
        downloadCsv={{
          downloadFunc: handleDownloadLinkageScore,
          disabled: isLoadingDownload ? true : false,
        }}
      >
        {isLoading ? (
          <div className="positionRelative" style={{ height: 200 }}>
            <Loading />
          </div>
        ) : (
          <div>{renderTable()}</div>
        )}
      </Panel>
    </>
  )
}

CorporateLinkageScore.propTypes = {
  isDynamicReport: PropTypes.bool,
}

CorporateLinkageScore.defaultProps = {
  isDynamicReport: false,
}
